import 'mdn-polyfills/NodeList.prototype.forEach';
import KeyNumber from './KeyNumber';

document.addEventListener('DOMContentLoaded', () => {
  const keyNumbers = document.querySelectorAll('.js-key-number');

  keyNumbers.forEach((element) => {
    const keyNumber = new KeyNumber(element);
    keyNumber.mount();
  });
});
